import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

import { useSettingsAccess } from '@/composables/useSettingsAccess'
import { buildSettingsTabs, firstSettingsPath } from '@/config/settingsTabs'


export default {
  __name: 'SettingsIndex',
  setup(__props) {

const router = useRouter()
const { hasFullAccess, capabilities, canManageUsers } = useSettingsAccess()

onMounted(() => {
  const tabs = buildSettingsTabs({
    hasFullAccess: hasFullAccess.value,
    capabilities: capabilities.value,
    canManageUsers: canManageUsers.value
  })
  router.replace(firstSettingsPath(tabs))
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

}